import {DataStatus} from 'platform/components';

import {lazy, Suspense} from 'react';

import {OrchestrationRouteBoundary} from '../OrchestrationRouteBoundary/OrchestrationRouteBoundary';

const LOADING_MIN_HEIGHT = 60;

// Loaded on the first visit, so the pages stay out of the initial bundle of every DMS user.
const PAGES = {
  list: lazy(() =>
    import('../../pages/RuleList/RuleList').then((module) => ({default: module.RuleList}))
  ),
  rule: lazy(() =>
    import('../../pages/RulePage/RulePage').then((module) => ({default: module.RulePage}))
  ),
  newEditor: lazy(() =>
    import('../../pages/RulePage/components/RuleNewEditorRoute').then((module) => ({
      default: module.RuleNewEditorRoute,
    }))
  ),
  edit: lazy(() =>
    import('../../pages/RulePage/components/RuleEditRoute').then((module) => ({
      default: module.RuleEditRoute,
    }))
  ),
} as const;

export type OrchestrationPage = keyof typeof PAGES;

interface OrchestrationRouteProps {
  page: OrchestrationPage;
}

/** The boundary wraps `Suspense`, so a page chunk that fails to load draws the route error. */
export function OrchestrationRoute(props: OrchestrationRouteProps) {
  const Page = PAGES[props.page];

  return (
    <OrchestrationRouteBoundary>
      <Suspense fallback={<DataStatus isLoading minHeight={LOADING_MIN_HEIGHT} />}>
        <Page />
      </Suspense>
    </OrchestrationRouteBoundary>
  );
}
